import { FC, ForwardedRef, forwardRef, useEffect, useState } from 'react';
import { MaskedInputProps } from './MaskedInput.types';
import { default as NumberFormat, NumberFormatValues, SourceInfo } from 'react-number-format';
import { ErrorText, HelpText, LabelWrapper, StyledInput, StyledLabel, Container } from '../Input/Input.styles';
import CharacterCount from '../Input/CharacterCount/CharacterCount';

const MaskedInput: FC<MaskedInputProps> = forwardRef(
  (
    {
      label,
      onChange,
      helpText,
      errorText,
      characterLimit,
      value,
      id,
      onValueChange,
      testId,
      isNumericString = true,
      ...props
    },
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    const [inputValue, setInputValue] = useState(value || '');

    useEffect(() => {
      setInputValue(value || '');
    }, [value]);

    const handleValueChange = (values: NumberFormatValues, sourceInfo: SourceInfo) => {
      if (onValueChange) onValueChange(values, sourceInfo);
      setInputValue(values.formattedValue);
    };

    return (
      <Container>
        <LabelWrapper>
          <StyledLabel htmlFor={id}>{label}</StyledLabel>
          {helpText ? <HelpText>{helpText}</HelpText> : <></>}
        </LabelWrapper>
        <NumberFormat
          {...props}
          id={id}
          getInputRef={ref}
          onValueChange={handleValueChange}
          value={inputValue}
          customInput={StyledInput}
          errorText={errorText}
          data-testid={testId ?? 'MaskedInput'}
          isNumericString={isNumericString}
        />
        {characterLimit ? <CharacterCount charactersRemaining={characterLimit - (inputValue?.length || 0)} /> : <></>}
        {errorText ? (
          <ErrorText aria-live='assertive' characterLimit={characterLimit}>
            {errorText}
          </ErrorText>
        ) : (
          <></>
        )}
      </Container>
    );
  }
);

export default MaskedInput;
